import FormTextTC from "../../../components/Forms/FormTextTC";
import React from "react";

export default function Dojo() {
  return (
    <>
      <FormTextTC
        name={"apiaccounts__dojo.dojo_username"}
        tDefault={"Dojo username"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.username"}
      />
      <FormTextTC
        name={"apiaccounts__dojo.dojo_password"}
        tDefault={"Dojo password"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.password"}
      />
      <FormTextTC
        name={"apiaccounts__dojo.dojo_terminal_id"}
        tDefault={"Dojo terminal id"}
        tKey={"vestigingen.form.primairbetallingsverkeer.label.terminal_id"}
      />
    </>
  );
}
